import { Component } from "react";

import { SpecialtyGroupException } from "@app/projects/results/common";
import { InfoIndicator } from "@app/shared";
import { SpecialtyGroupExceptionHistoryTimeline } from "./SpecialtyGroupExceptionHistoryTimeline";
import { FlyoutLink } from "@app/shared/Flyouts";

interface SpecialtyExceptionTimelineLinkProps {
  projectId?: number;
  regionSetSpecialtyGroupId?: number;
  specialtyGroupException?: SpecialtyGroupException;
  showHistory: boolean;
  visible: boolean;
}

export default class SpecialtyExceptionTimelineLink extends Component<SpecialtyExceptionTimelineLinkProps> {

  public render() {
    if (!this.props.visible) {
      return null;
    }

    const indicator = this.props.showHistory
      ? (
        <FlyoutLink
          classNames="specialty-history-link text-dark p-0"
          content={{
            body: <SpecialtyGroupExceptionHistoryTimeline regionSetSpecialtyGroupId={this.props.regionSetSpecialtyGroupId} projectId={this.props.projectId} specialtyGroupException={this.props.specialtyGroupException} />,
            title: "Specialty Exception History",
          }}
          testId="specialty-group-exception-timeline-link__history-flyout"
        >
          <InfoIndicator className={"fa fa-history"} tooltipTitle={"Show Exception Timeline Details"} tooltipPlacement={"right"} />
        </FlyoutLink>
      )
      : <span className="specialty-history-link" />;

    return (
      <>{indicator}&nbsp;</>
    );
  }

}
